<template>
  <div class="body-container">
    <section class="notifications">
      <div class="notification-container container">
        <div class="notification-title">
          <h2><span class="bricsa-square"></span>Mis Notificaciones</h2>
          <p>De los últimos 15 días</p>
        </div>
        <v-alert
            v-if="cantidadNotificaciones == 0 && loading == false"
            outlined
            type="information"
          >
            No existen notificaciones disponibles.
          </v-alert>
        <div class="notification-group">        
          <div
            class="notification-items"
            v-for="(noti, index) in notificaciones.notificaciones"
            :class="noti.leida?'leida':'no-leida'"
            :key="index">
            
            <!-- En caso de que el link sea interno -->
            <a>
              <div class="notification-item__title">
                <h3> 
              <span
                class="bricsa-square"
                :class="[
                  noti.tipoMensaje == 'Avance' ? 'notiRed' : '',
                  noti.tipoMensaje == 'Cambio estado solicitud' ? 'notiOrange' : '',
                  noti.tipoMensaje == 3 ? 'notiBlue' : '',
                  noti.tipoMensaje == 4 ? 'notiSkiBlue' : '',
                  noti.tipoMensaje == 5 ? 'notiGrey' : '',
                ]"
              ></span
              >{{ noti.tipoMensaje }}
            </h3>
                <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro">Ver
                </button>
                 <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro==false"
                  >Ver
                 </button>
              </div>
              <div class="notification-item__info">
                <p>{{ noti.mensaje }}</p>
              </div>
              <div class="text-right mr-5">
                <i class="fa fa-envelope" aria-hidden="true" v-show="noti.leida==false"></i>
                <i class="fa fa-envelope-open" aria-hidden="true" v-show="noti.leida"></i>
                </div>
            </a>
          </div>
        </div>
        <section class="adBanner container">
          <img :src="images.family" alt="" />
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GET_NOTIFICACIONES, UPDATE_NOTIFICACION } from "@/core/services/store/notificacion.module";
export default {
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg'
            },
      loading:true
    };
  },
  mounted () {
    this.getNotificaciones();
  },
  methods: {
    getNotificaciones() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_NOTIFICACIONES, null)
          .then(()=>{
            this.$Progress.finish(),
            this.loading=false
      });
    },
    updateNotificacion(notificacion) {
      this.$Progress.start();
      this.$store
          .dispatch(UPDATE_NOTIFICACION, notificacion)
          .then(()=>{
            this.$store.dispatch(GET_NOTIFICACIONES, null).then(() => {
              this.$Progress.finish(),
              this.loading=false;
              if(notificacion.modulo!='' && notificacion.parametro){
                this.$router.push({ name: notificacion.modulo, params: { idNegocio: notificacion.idNegocio } });
              } else if(notificacion.modulo!='' && notificacion.parametro==false){
                this.$router.push({ name: notificacion.modulo });
              }
            });
      });
    }
  },
  computed: {
    ...mapState({
      notificaciones :state => state.notificacion.notificaciones,
    }),
    cantidadNotificaciones() {
      if (typeof this.notificaciones.notificaciones == "undefined") return 0;
      return this.notificaciones.notificaciones.length;
    },
  },
  
};
</script>

<style lang="scss" scoped>
.container {
  padding: 3% 5% !important;
}
.notifications {
  width: 100%;
  padding: 0;
  background: transparent;
  .notification-container {
    padding: 10px !important;
    @media screen and(max-width:1024px) {
      padding: 3% 0 !important;
    }
    .notification-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
        display: flex;
        align-items: baseline;
        span {
          display: block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          background: var(--bricsa-red);
        }
      }
      p{
        color: #707070;
      }
    }
    .notification-group {
      padding: 3% 5%;
      display: grid;
      grid-template-columns: repeat(4, 24%);
      justify-content: space-between;
      row-gap: 10px;
      @media screen and (max-width: 1025px) {
        grid-template-columns: 100%;
      }
      .leida{
          background: #f0f0f0;
          border: 1px solid #ccc;
        }
      .notification-items {
        padding-bottom: 10px;
        -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        
        .notification-item__title {
          display: flex;
          justify-content: space-between;
          h3 {
            width: fit-content;
            color: #7e7e7e;
            font-weight: bold;
            text-align: left;
            display: flex;
            align-items: baseline;
            margin: 10px 0 0;
            padding-right: 10px;
            span {
              display: block;
              width: 10px;
              height: 10px;
              margin-right: 5px;
              background: var(--bricsa-red);
            }
            .notiRed {
              background-color: var(--bricsa-red);
            }
            .notiOrange {
              background-color: var(--bricsa-orange);
            }
            .notiBlue {
              background-color: var(--bricsa-blue);
            }
            .notiSkiBlue {
              background-color: var(--bricsa-skiblue);
            }
            .notiGrey {
              background-color: var(--bricsa-grey);
            }
          }
          a, button {
            height: fit-content;
            padding: 1px 15px;
            margin: 10px 10px 0 0;
            font-size: 12px;
            font-weight: bold;
            color: var(--bricsa-red);
            border: solid 2px var(--bricsa-red);
          }
        }
        .notification-item__info {
          p {
            padding: 10px;
            color: #7e7e7e;
            font-size: 12px;
            text-align: left;
            overflow: hidden;
            height: calc(1.3rem * 3);
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
.adBanner {
  width: 100%;
  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    object-position: center 30%;
    @media screen and(max-width:1025px) {
      height: 150px;
    }
  }
}
</style>